import React from "react";
import food1 from '../../assets/images/download_food1.webp';
import food3 from '../../assets/images/download_food3.webp';
import googleplay from '../../assets/images/googleplay.webp';
import appstorebtn from '../../assets/images/appstorebtn.webp';
import food2 from '../../assets/images/download_food2.webp';
import { Link } from 'react-router-dom';
const Download = () => {
    return (
        <>

            <section className="row_am download_app_new" id="download_sec">

                <div className="dap_block" data-aos="fade-up" data-aos-duration={1500}>

                    <div className="blure_shape bs_1"> </div>

                    <div className="row">

                        <div className="col-lg-3 col-md-12 order-2 order-lg-1">
                            <div className="dap_image left">
                                <img
                                    className="dap_desktop_img"
                                    src={food1}
                                    alt="image"
                                />
                                <img
                                    className="dap_mobile_img"
                                    src={food3}
                                    alt="image"
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12 order-1 order-lg-2">

                            <div className="dap_text">

                                <div
                                    className="section_title white_text"
                                    data-aos="fade-up"
                                    data-aos-duration={1500}
                                    data-aos-delay={100}
                                >
                                    <span className="title_badge">Download</span>
                                    <h2>Download app to enjoy 4500+ foods from 1200+ restaurants </h2>
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing indus orem
                                        Ipsum has been the industrys.
                                    </p>
                                </div>

                                <ul className="app_btn" data-aos="fade-up" data-aos-duration={1500}>
                                    <li>
                                        <Link to="#">
                                            <img
                                                className="blue_img"
                                                src={googleplay}
                                                alt="image"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <img
                                                className="blue_img"
                                                src={appstorebtn}
                                                alt="image"
                                            />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-12 order-3 order-lg-3 d-none d-lg-block">
                            <div className="dap_image right">
                                <img src={food2} alt="image" />
                            </div>
                        </div>
                    </div>

                </div>

            </section>

        </>


    )


}
export default Download;
